import i18n from '../../../i18n/index'
export default {
  data() {
    return {
      controlledMedicine: true,
      applicableMedicine: false,
      spoiledMedicine: false,
      search: "",
      headers: [
        {
          text: i18n.t('headers.document'),
          sortable: false,
          value: "document"
        },
        {
          text: i18n.t('headers.name'),
          sortable: false,
          value: "fullname"
        },
        {
          text: i18n.t('headers.cellphone'),
          sortable: false,
          value: "mobilePhone"
        },
        {
          text: i18n.t('headers.phone'),
          sortable: false,
          value: "phone"
        },
        {
          text: i18n.t('headers.income-group'),
          sortable: false,
          value: "idIncomeGroup"
        },
        {
          text: i18n.t('headers.policy'),
          sortable: false,
          value: "isPolicy"
        },
        {
          text: i18n.t('headers.pac'),
          sortable: false,
          value: "isPac"
        },
        {
          text: i18n.t('headers.actions'),
          sortable: false,
          value: "actions"
        }
      ],
      itemsData: [],
      newMobilPhoneNumber: null,
      newPhoneNumber: null
    };
  },
  props: {
    patientListData: {
      type: Array,
      default: () => []
    },
    deletePatient: {
      type: Function,
      default: () => { }
    },
    saveMobilePhone: {
      type: Function,
      default: () => { }
    },
    savePhone: {
      type: Function,
      default: () => { }
    },
    order: {
      type: Object,
      default: () => { }
    },
    buttonSaveDisable: {
      type: Function,
      default: () => { }
    },
  },
  watch: {},
  filters: {
    celular(patient) {
      return  patient.item.mobilePhone;
    }
  },
  methods: {
    onRowClick(item) {
      this.$emit("row-click", item);
    },
    filterKeyCount(e) {
      const key = e.key
      if (/[0-9]/.test(key)) { } else { return e.preventDefault() }
    },

    handlePasteCellPhone(patient, event) {
      const cleanedText = event.target.value.match(/\d/g, '')
      const textoDefinitivo = cleanedText ? cleanedText.slice(0, 10).join('') : ''
      this.patientListData[patient.index] = {...patient.item, mobilePhone: textoDefinitivo}
      patient.item.mobilePhone = textoDefinitivo;
      this.newMobilPhoneNumber = textoDefinitivo
    },

    handlePastePhone(patient,event) {
      const cleanedText = event.target.value.match(/\d/g, '');
      const textoDefinitivo = cleanedText ? cleanedText.slice(0, 7).join('') : ''
      this.patientListData[patient.index] = {...patient.item, phone: textoDefinitivo}
      patient.item.phone = textoDefinitivo;
      this.newPhoneNumber = textoDefinitivo
    }
  }
};
